module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("anD7r"))).then(() => parcelRequire('8rm4T'));